import en from "./Language/en";
import gu from "./Language/gu";


const translations = { en, gu };

export default translations;
